
export const selectUserId = (state) => state.user?._id;
export const selectUser = (state) => state.user;
export const selectRole = (state) => state.user?.role;